import * as z from 'zod';

export const ListCurrenciesRequest = z.object({});
export const ListCurrenciesResponse = z.object({
  currencies: z
    .array(
      z.object({
        code: z.string().describe('Currency code.').optional(),
        symbol: z.string().describe('Currency symbol.').max(10).optional(),
      })
    )
    .optional(),
});
export const ConvertCurrencyRequest = z.object({
  identifiers: z
    .object({
      from: z.string().describe('Original currency.'),
      to: z.string().describe('Target currency.'),
    })
    .describe(
      'Identifying details needed to determine which currency rate to convert. The combination of the `from` and `to` properties together comprise the unique ID. '
    ),
  amounts: z
    .array(
      z.object({
        value: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Value without decimals (e.g., for 10.95 value will be 1095).'
          )
          .optional(),
        decimalPlaces: z
          .number()
          .int()
          .describe(
            'Decimal places to apply (e.g., for 10.95 decimal_places will be 2).'
          )
          .optional(),
      })
    )
    .min(1)
    .max(100),
});
export const ConvertCurrencyResponse = z.object({
  amounts: z
    .array(
      z.object({
        value: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Value without decimals (e.g., for 10.95 value will be 1095).'
          )
          .optional(),
        decimalPlaces: z
          .number()
          .int()
          .describe(
            'Decimal places to apply (e.g., for 10.95 decimal_places will be 2).'
          )
          .optional(),
      })
    )
    .optional(),
  rateTimestamp: z
    .date()
    .describe('Date and time the conversion rate was last updated.')
    .optional()
    .nullable(),
});
export const GetConversionRateRequest = z.object({
  identifiers: z
    .object({
      from: z.string().describe('Original currency.'),
      to: z.string().describe('Target currency.'),
    })
    .describe(
      'Identifying details needed to determine which currency rate to retrieve. The combination of the `from` and `to` properties together comprise the unique ID. '
    ),
});
export const GetConversionRateResponse = z.object({
  rate: z
    .object({
      value: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Value without decimals (e.g., for 10.95 value will be 1095).'
        )
        .optional(),
      decimalPlaces: z
        .number()
        .int()
        .describe(
          'Decimal places to apply (e.g., for 10.95 decimal_places will be 2).'
        )
        .optional(),
    })
    .describe('Conversion rate between 2 currencies.')
    .optional(),
  rateTimestamp: z
    .date()
    .describe('Date and time the conversion rate was last updated.')
    .optional()
    .nullable(),
});
